import styled from 'styled-components'
import { css, rgba, media, colors, input } from 'styles'

const StyledMyProfile = styled.form`
  display: flex;

  .col {
    flex: 1 0 40%;
    max-width: calc(50% - 2.5vw);
    .col {
      max-width: calc(50% - 1rem);
    }
  }

  input:invalid:not(:focus) {
    border-color: tomato;
  }

  .gallery-wrapper {
    margin-right: 2rem;
    margin-bottom: 2rem;
  }

  .gallery-wrapper button {
    margin: 1rem 0;
    width: 100%;
  }

  ${media.mobile`
    flex-direction: column;

    .col, .col .col {
      width: 100%;
      max-width: 100%;
    }
    .gallery-wrapper button.sticky {
      position: fixed;
      top: 1rem;
      z-index: 1;
      width: 95%;
    }
  `}
`

const MyProfileLeft = styled.div`
  margin-right: 5vw;

  display: flex;
  flex-direction: row;

  ${media.mobile`
    justify-content: center;
    margin-right: 0;
    margin-bottom: 6rem;
    .col.col {
      width: calc(50% - 1em);
    }
  `}

  ${media.phone`
    flex-direction: column;
    .col.col {
      width: 100%;
    }
  `}
`

const MyProfileRight = styled.div`
  .tabs {
    width: 100%;
    border-bottom: 1px solid ${rgba(colors.textMain, 0.6)};
    display: flex;

    a {
      padding: 0 0.5rem 1.2rem;
      text-align: center;
      box-sizing: border-box;
      font-size: 1.4rem;
      text-transform: uppercase;
      text-decoration: none;
      color: ${rgba(colors.textMain, 0.6)};
      flex: 1;

      &:hover {
        color: ${colors.textMain};
      }

      &.active {
        border-bottom: 3px solid ${colors.textMain};
        color: ${colors.textMain};
        font-weight: 700;
      }
    }
  }
  .info-details > .hidden {
    display: none;
  }
  .block {
    flex: 1 0 40%;
    max-width: calc(50% - 1em);

    &:nth-child(2n) {
      margin-left: 2rem;
    }
    &:only-child {
      max-width: 100%;
    }
  }
  .row {
    flex: 100%;
    display: flex;
    flex-wrap: wrap;
  }
  ${media.mobile`
    .tabs {
      display: flex;
      justify-content: space-evenly;
      padding-bottom: 0;
    }

    .info-details {
      padding-bottom: 4rem;
    }
  `}
  ${media.phone`
    .block {
      flex: 100%;
      max-width: 100%;

      &:nth-child(2n) {
        margin-left: 0rem;
      }
    }
  `}
`

const StyledBlock = styled.div`
  margin-bottom: 1rem;
  position: relative;

  .name {
    margin: 0 0 0.5rem 0.5rem;
    font-size: 1.2rem;
    font-weight: 400;
    color: ${colors.textSecondary};
    text-transform: capitalize;
  }
  .message {
    position: absolute;
    top: 0;
    right: 0;
  }
  input.highlighted {
    box-shadow: 0 0 3px;
  }

  .value {
    width: 100%;

    ${p =>
      p.textOnly &&
      css`
        display: flex;
        align-items: center;
        ${input.outer};
        padding: ${input.padding};
        border-radius: ${input.borderRadius};
        background-color: ${rgba(colors.divider, 0.3)};
        opacity: 0.8;
      `}
  }

  ${p =>
    p.type === 'row' &&
    css`
      display: flex;
    `}
  textarea {
    height: 10rem;
  }
  ${media.mobile`
    .value {
      width: 100%;
      font-size: 1.6rem;
    }
    input, textarea {
      font-size: 1.6rem;
    }
    textarea:empty {
      height: 8rem;
    }
    textarea {
      height: 12rem;
      line-height: 1.4;
    }
    .name {
      font-size: 1.4rem;
    }
    margin-bottom: 1.5rem;
  `}
`

export default StyledMyProfile
export { StyledBlock, MyProfileLeft, MyProfileRight }
